import React from 'react';
import classNames from 'classnames';

interface IProps {
  className?: string;
  children?: React.ReactNode;
  isScrolledFromBottom?: boolean;
}

const PageFooter = ({ className, children, isScrolledFromBottom }: IProps): JSX.Element => {
  // const { isScrolledFromBottom } = useScrollStatus('page-main-scrollable');

  return (
    <footer
      className={classNames(
        'page-footer',
        { 'page-footer--shadow': isScrolledFromBottom },
        className,
      )}
    >
      {children}
    </footer>
  );
};

export default PageFooter;
